import { takeEvery, put, call, getContext } from "redux-saga/effects";
import { push } from "react-router-redux";
import {
  NAVIGATE,
  RELOAD,
  REACT_ROUTER_LOCATION_CHANGE,
  CLEAR_ACCOUNT_DATA
} from "constants/actionTypes";

/**
 * Wrap route navigation with a saga until such time as we can decouple
 * the standalone React app from the injected Backbone routes.
 *
 * Saga determines if Backbone is installed, and if so, defers to its
 * router.  Otherwise dispatches a react-router-redux history push.
 *
 * @param action
 */

export function* navigate(action) {
  const { path, openInNewTab } = action.payload;
  if (window.Backbone) {
    window.Backbone.history.navigate(path, { trigger: true });
  } else if (openInNewTab) {
    yield call(navigateInNewTab, path);
  } else {
    yield put(push(path));
  }
}

// eslint-disable-next-line require-yield
export function* reload() {
  window.location.reload();
}

// eslint-disable-next-line require-yield
function* navigateInNewTab(path) {
  window.open(path, "_blank");
}

function* onReactRouterLocationChange() {
  const auth = yield getContext("auth");
  const isSpoofing = yield call(auth.isSpoofing);
  // If Backbone is defined, managing page() calls
  // will be taken care of by Backbone, so only call
  // analytics.page() when it isnt defined.
  if (!isSpoofing && !!window.analytics && !window.Backbone) {
    // We need to pass a category for this page view. This is used in the
    // index.html file to send the Viewed App Page event which we use in our
    // analytics.
    window.analytics.page("App");
  }
}

function* navigateToDashboard() {
  yield put(push("/"));
}

export default function* routing() {
  yield takeEvery(NAVIGATE, navigate);
  yield takeEvery(RELOAD, reload);
  yield takeEvery(REACT_ROUTER_LOCATION_CHANGE, onReactRouterLocationChange);
  yield takeEvery(CLEAR_ACCOUNT_DATA, navigateToDashboard);
}
